exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "textarea.care-team-tasks--2ZYIqSMLfROy_7xn8wjejO {\n  line-height: 1.25rem;\n  padding: .25rem 1.25rem;\n}\n\ntextarea.care-team-tasks--2ZYIqSMLfROy_7xn8wjejO:not(:first-child) {\n  margin: .125rem 0;\n}\n\ntextarea.care-team-tasks--2ZYIqSMLfROy_7xn8wjejO,\ntextarea.care-team-tasks--2ZYIqSMLfROy_7xn8wjejO:focus {\n  border: none;\n  box-shadow: none;\n}\n", ""]);

// exports
exports.locals = {
	"checklistFormField": "care-team-tasks--2ZYIqSMLfROy_7xn8wjejO",
	"checklistFormField": "care-team-tasks--2ZYIqSMLfROy_7xn8wjejO"
};